import { render } from "./UnitedTwo.vue?vue&type=template&id=33ef4b72"
import script from "./UnitedTwo.vue?vue&type=script&lang=js"
export * from "./UnitedTwo.vue?vue&type=script&lang=js"

import "./UnitedTwo.vue?vue&type=style&index=0&id=33ef4b72&lang=css"
script.render = render

export default script